/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_UnrecognizedInputs */

const en_us2_error_unrecognized = /** @type {(inputs: Error_UnrecognizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Update the app and try again.`)
};

const pt_br2_error_unrecognized = /** @type {(inputs: Error_UnrecognizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado. Atualize o app e tente de novo.`)
};

const es_419_error_unrecognized = /** @type {(inputs: Error_UnrecognizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal. Actualiza la app e intenta de nuevo.`)
};

const pt_pt2_error_unrecognized = /** @type {(inputs: Error_UnrecognizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo correu mal. Atualiza a app e tenta outra vez.`)
};

const fr_fr2_error_unrecognized = /** @type {(inputs: Error_UnrecognizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un problème est survenu. Mets l'appli à jour et réessaie.`)
};

const de_de2_error_unrecognized = /** @type {(inputs: Error_UnrecognizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schiefgelaufen. Aktualisiere die App und versuch es noch mal.`)
};

const it_it2_error_unrecognized = /** @type {(inputs: Error_UnrecognizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcosa è andato storto. Aggiorna l'app e riprova.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Update the app and try again." |
*
* @param {Error_UnrecognizedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const error_unrecognized = /** @type {((inputs?: Error_UnrecognizedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_UnrecognizedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_error_unrecognized(inputs)
	if (locale === "es-419") return es_419_error_unrecognized(inputs)
	if (locale === "pt-PT") return pt_pt2_error_unrecognized(inputs)
	if (locale === "fr-FR") return fr_fr2_error_unrecognized(inputs)
	if (locale === "de-DE") return de_de2_error_unrecognized(inputs)
	if (locale === "it-IT") return it_it2_error_unrecognized(inputs)
	return en_us2_error_unrecognized(inputs)
});
export { error_unrecognized as "error.unrecognized" }